<template>
    <div class="content">
        <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                <md-card>
                    <md-card-header data-background-color="primary">
                        <div class="flex-container">
                            <h4 class="title">Projects</h4>
                            <md-field md-clearable class="search">
                                <md-input v-model="searchInput" placeholder="Search by name..." type="text"></md-input>
                            </md-field>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <md-table table-header-color="primary">
                            <md-table-row>
                                <md-table-head>ID</md-table-head>
                                <md-table-head>Name</md-table-head>
                            </md-table-row>
                            <md-progress-spinner v-if="loading" md-mode="indeterminate" class="center"></md-progress-spinner>
                            <md-table-row v-for="project in filteredProjects" v-bind:key="project.id">
                                <md-table-cell>{{ project.id }}</md-table-cell>
                                <md-table-cell>
                                    <router-link :to="{name: 'Project details', params: { id: project.jira_project_id }}">{{ project.name }}</router-link>
                                </md-table-cell>
                            </md-table-row>
                        </md-table>
                    </md-card-content>
                </md-card>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import axios from "@/axios";

export default {
    name: "projects",
    data() {
        return {
            loading: false,
            projects: [],
            searchInput: ""
        };
    },
    computed: {
        filteredProjects() {
            return this.projects.filter(project => {
                return (
                    project.name.toLowerCase().includes(this.searchInput.toLowerCase()) ||
                    this.searchInput == ""
                );
            });
        }
    },
    methods: {
        fetch() {
        this.loading = true;
        axios.get("/projects")
            .then(e => {
                this.projects = e.data;
                this.loading = false;
            });
        }
    },
    mounted() {
        this.fetch();
    }
};
</script>

<style scoped>
.flex-container{
    display: flex;
}

.title{
    float:left;
    top: 50%;
    margin-right: 100px;
    position: relative;
    text-align: center; 
}

.search{
    overflow:hidden;
    flex:1 0 0;
}

.center{
    margin: 0 auto;
}
</style>
